import { render, staticRenderFns } from "./AttachmentCount.vue?vue&type=template&id=c3ee9924&"
import script from "./AttachmentCount.vue?vue&type=script&lang=js&"
export * from "./AttachmentCount.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentCount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports